import { ChartImages } from '../models';

export const INITIAL_CHART_IMAGES: ChartImages = {
    currentOverSpeed: null,
    currentOverTime: null,
    powerOverSpeed: null,
    timeOverSpeed: null,
    torqueOverSpeed: null
};
